import { SnackbarResource } from "../locales";

export const snackbar: SnackbarResource = {
    addToCartSuccess: "Le panier a été mis à jour.",
};
